/**
 * Program 12.1 UX4 — Commercial deviations register (proposal meta_json).
 */
export type DeviationSeverity = 'ACCEPT' | 'CLARIFY' | 'DEVIATE' | 'HIGH_RISK';

export type CommercialDeviationRow = {
  id: string;
  clause: string;
  client_requirement: string;
  bid_position: string;
  deviation?: string;
  risk?: DeviationSeverity;
  status?: string;
  approved?: boolean;
};

export function parseCommercialDeviations(meta: unknown): CommercialDeviationRow[] {
  if (!meta || typeof meta !== 'object') return [];
  const m = meta as Record<string, unknown>;
  const raw = m.deviations ?? m.commercial_deviations;
  return Array.isArray(raw) ? (raw as CommercialDeviationRow[]) : [];
}

export function mergeDeviationsMeta(
  meta: Record<string, unknown> | null | undefined,
  deviations: CommercialDeviationRow[]
): Record<string, unknown> {
  return { ...(meta || {}), deviations };
}

export const DEFAULT_DEVIATION_TEMPLATE: CommercialDeviationRow[] = [
  {
    id: 'pay-1',
    clause: 'Payment',
    client_requirement: '120 days',
    bid_position: '60 days',
    risk: 'HIGH_RISK',
    status: 'Pending',
    approved: false,
  },
];
